import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Box, Button, IconButton, Typography, useTheme } from '@mui/material';
import { IosArrowLtr24Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import SearchInput from '@ui/components/common/GlobalSearchInput';
import HeaderConfig from '@infrastructure/route-config';
import useHeaderStyles from './useHeaderStyles';
const Header = () => {
    const { t } = useTranslation();
    const headerConfig = HeaderConfig(t);
    const theme = useTheme();
    const isLightMode = theme.palette.mode === 'light';
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams(); // Get dynamic route parameters
    const { MobileHeaderContainer, SearchBarContainer, NavTitleContainer, NavInner, markAsReadButtonStyles } = useHeaderStyles();
    const [search, setSearch] = useState('');
    const handleChangeSearch = ({ target: { value } }) => {
        setSearch(value);
    };
    const handleBackClick = () => {
        navigate(-1); // Navigate back
    };
    // Find matching config
    const routeKey = Object.keys(headerConfig).find((route) => {
        const routePattern = new RegExp('^' + route.replace(/:[^/]+/g, '[^/]+') + '$');
        return routePattern.test(location.pathname);
    });
    if (!routeKey)
        return null;
    const config = routeKey
        ? headerConfig[routeKey]
        : { showSearchBar: false, showBackButton: false, title: '' };
    const resolvedTitle = typeof config.title === 'function' ? config.title(params) : config.title;
    return (_jsx(_Fragment, { children: !!config.showheader && (_jsxs(Box, { sx: MobileHeaderContainer, className: 'mobile-nav-container', children: [_jsxs(Box, { className: 'nav-inner', sx: NavInner, children: [_jsxs(Box, { sx: NavTitleContainer, className: 'nav-title', children: [!!config.showBackButton && (_jsx(IconButton, { "aria-label": 'back', onClick: handleBackClick, sx: { p: 0 }, children: _jsx(IosArrowLtr24Regular, { fontSize: 24, color: isLightMode ? 'white' : theme.palette.grey[900] }) })), _jsx(Typography, { variant: 'h4', className: 'mobile-nav-title', color: isLightMode ? 'white' : theme.palette.grey[900], children: resolvedTitle })] }), !!config.showMarkAsRead && (_jsx(Button, { size: 'small', variant: 'text', sx: markAsReadButtonStyles, children: t('MarkAsRead') }))] }), !!config.showSearchBar && (_jsx(Box, { className: 'searchbar-container', sx: SearchBarContainer, children: _jsx(SearchInput, { value: search, onChange: handleChangeSearch }) }))] })) }));
};
export default Header;
